module.exports = __webpack_public_path__ + "static/media/menu.5910c776.png";